
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../home/components/Navigation';
import Footer from '../home/components/Footer';
import ContactForm from '../home/components/ContactForm';
import WhatsAppButton from '../home/components/WhatsAppButton';
import FloatingButtons from '../home/components/FloatingButtons';
import CookieBanner from '../home/components/CookieBanner';

const SaintOrens = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navigation />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-teal-50 via-white to-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Réparation de fenêtres à <strong className="text-teal-600">Saint-Orens-de-Gameville</strong>
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
              Intervention rapide à Saint-Orens (31650) - À seulement 10 km de Toulouse
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a
                href="tel:0554542545"
                className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-teal-500 to-teal-600 text-white rounded-full font-semibold text-lg hover:from-teal-600 hover:to-teal-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                05 54 54 25 45
              </a>
              <a
                href="#contact"
                className="inline-flex items-center px-8 py-4 bg-white text-teal-600 rounded-full font-semibold text-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl border-2 border-teal-600 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line mr-2"></i>
                Devis Gratuit
              </a>
            </div>
          </div>

          {/* Badges */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
            <div className="bg-white rounded-lg p-4 shadow-md text-center">
              <i className="ri-time-line text-3xl text-teal-600 mb-2"></i>
              <p className="font-semibold text-gray-900">Intervention</p>
              <p className="text-sm text-gray-600">sous 2h</p>
            </div>
            <div className="bg-white rounded-lg p-4 shadow-md text-center">
              <i className="ri-map-pin-line text-3xl text-teal-600 mb-2"></i>
              <p className="font-semibold text-gray-900">10 km</p>
              <p className="text-sm text-gray-600">de Toulouse</p>
            </div>
            <div className="bg-white rounded-lg p-4 shadow-md text-center">
              <i className="ri-shield-check-line text-3xl text-teal-600 mb-2"></i>
              <p className="font-semibold text-gray-900">Garantie</p>
              <p className="text-sm text-gray-600">décennale</p>
            </div>
            <div className="bg-white rounded-lg p-4 shadow-md text-center">
              <i className="ri-24-hours-line text-3xl text-teal-600 mb-2"></i>
              <p className="font-semibold text-gray-900">Urgence</p>
              <p className="text-sm text-gray-600">24h/24</p>
            </div>
          </div>
        </div>
      </section>

      {/* Problèmes spécifiques à Saint-Orens */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center">
            Problèmes de fenêtres fréquents à <strong className="text-teal-600">Saint-Orens</strong>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-gray-50 to-white rounded-lg p-6 shadow-md">
              <div className="w-16 h-16 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-home-4-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Maisons pavillonnaires</h3>
              <p className="text-gray-600">
                Saint-Orens compte de nombreux pavillons récents avec des fenêtres PVC nécessitant un entretien régulier des joints et mécanismes.
              </p>
            </div>

            <div className="bg-gradient-to-br from-gray-50 to-white rounded-lg p-6 shadow-md">
              <div className="w-16 h-16 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-sun-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Exposition sud</h3>
              <p className="text-gray-600">
                Forte exposition solaire causant la déformation des cadres PVC et la dégradation des joints d'étanchéité sur les façades sud.
              </p>
            </div>

            <div className="bg-gradient-to-br from-gray-50 to-white rounded-lg p-6 shadow-md">
              <div className="w-16 h-16 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-sound-module-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Isolation phonique</h3>
              <p className="text-gray-600">
                Proximité de la rocade et des axes routiers nécessitant un double vitrage renforcé pour une meilleure isolation acoustique.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center">
            Nos services à Saint-Orens-de-Gameville
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: 'ri-hammer-line', title: 'Réparation fenêtre', desc: 'Vitres cassées, fissurées ou endommagées' },
              { icon: 'ri-stack-line', title: 'Double vitrage', desc: 'Remplacement et réparation' },
              { icon: 'ri-door-line', title: 'Volets roulants', desc: 'Dépannage et motorisation' },
              { icon: 'ri-window-line', title: 'Baies vitrées', desc: 'Installation et réparation' },
              { icon: 'ri-lock-line', title: 'Serrures', desc: 'Changement de poignées et serrures' },
              { icon: 'ri-flashlight-line', title: 'Urgence 24h/24', desc: 'Intervention rapide' }
            ].map((service, index) => (
              <div key={index} className="bg-white rounded-lg p-6 shadow-md hover:shadow-lg transition-all">
                <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-2xl text-teal-600`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{service.title}</h3>
                <p className="text-gray-600 text-sm">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quartiers */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center">
            Quartiers desservis à Saint-Orens
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              'Centre-ville',
              'Gameville',
              'Lapujade',
              'Côte Pavée',
              'Bois Vert',
              'Les Pins',
              'Montcalm',
              'La Ramée'
            ].map((quartier, index) => (
              <div key={index} className="bg-gradient-to-br from-teal-50 to-white rounded-lg p-4 text-center shadow-sm hover:shadow-md transition-all">
                <i className="ri-map-pin-2-line text-2xl text-teal-600 mb-2"></i>
                <p className="font-semibold text-gray-900">{quartier}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Témoignages locaux */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center">
            Avis de clients à Saint-Orens
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                name: 'Sophie M.',
                quartier: 'Gameville',
                rating: 5,
                text: 'Intervention très rapide pour une fenêtre cassée. Équipe professionnelle et prix correct. Je recommande !'
              },
              {
                name: 'Laurent D.',
                quartier: 'Centre-ville',
                rating: 5,
                text: 'Excellent service pour le remplacement de mon double vitrage. Travail soigné et propre.'
              },
              {
                name: 'Marie P.',
                quartier: 'Lapujade',
                rating: 5,
                text: 'Dépannage en urgence un dimanche. Très réactifs et efficaces. Merci beaucoup !'
              }
            ].map((testimonial, index) => (
              <div key={index} className="bg-white rounded-lg p-6 shadow-md">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mr-3">
                    <i className="ri-user-line text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <p className="font-bold text-gray-900">{testimonial.name}</p>
                    <p className="text-sm text-gray-600">{testimonial.quartier}</p>
                  </div>
                </div>
                <div className="flex mb-3">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400"></i>
                  ))}
                </div>
                <p className="text-gray-600 text-sm">{testimonial.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Villes voisines */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center">
            Nous intervenons aussi dans les villes voisines
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
            {[
              { name: 'Toulouse', path: '/' },
              { name: 'Balma', path: '/balma' },
              { name: 'Ramonville', path: '/ramonville' },
              { name: 'L\'Union', path: '/lunion' },
              { name: 'Colomiers', path: '/colomiers' },
              { name: 'Blagnac', path: '/blagnac' },
              { name: 'Tournefeuille', path: '/tournefeuille' },
              { name: 'Muret', path: '/muret' },
              { name: 'Cugnaux', path: '/cugnaux' },
              { name: 'Plaisance', path: '/plaisance-du-touch' }
            ].map((ville, index) => (
              <Link
                key={index}
                to={ville.path}
                className="bg-gradient-to-br from-teal-50 to-white rounded-lg p-4 text-center shadow-sm hover:shadow-md transition-all cursor-pointer"
              >
                <i className="ri-map-pin-line text-2xl text-teal-600 mb-2"></i>
                <p className="font-semibold text-gray-900">{ville.name}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <ContactForm />
      <Footer />
      <WhatsAppButton />
      <FloatingButtons />
      <CookieBanner />
    </>
  );
};

export default SaintOrens;
